import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CalendarComponent } from 'ionic2-calendar/calendar';
import { MonthViewComponent } from 'ionic2-calendar/monthview';
import { WeekViewComponent } from 'ionic2-calendar/weekview';
import { DayViewComponent } from 'ionic2-calendar/dayview';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
//Providers
import { AgendaProvider } from '../../providers/agenda-provider';
import { UtilProvider } from '../../providers/util-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { StorageProvider } from '../../providers/storage-provider'
//Models
import { Agenda, AgendaAtividade } from '../../models/agenda.model';
import { User } from '../../models/user.model';
import { Program } from '../../models/program.model';
import { AtividadePage } from '../atividade/atividade';
import { Congresso } from '../../models/congresso.model';
import { DayProgram } from '../../models/day-program.model';

@Component({
    selector: 'page-agenda',
    templateUrl: 'agenda.html',
})
export class AgendaPage {
    @ViewChild(CalendarComponent) selfCalendar: CalendarComponent;

    private congresso: Congresso;
    private storage = window.localStorage;
    private currentActivities: AgendaAtividade[];
    private currentDay: number = 0;
    private days = [];
    private isToday: boolean;
    private lockSwipes: boolean;
    private lastRefreshDate: string;
    private activitiesInscIds: number[];
    private calendar = {
        mode: 'day',
        currentDate: new Date()
    };

    public eventSource = [];
    public program: Program;
    public color: "";

    constructor(private nav: NavController,
        private agendaProvider: AgendaProvider,
        private auth: AuthProvider,
        private alert: CustomAlert,
        private storageProvider: StorageProvider,
        private utilProvider: UtilProvider) {
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
    }

    ionViewWillEnter() {
        this.setOpacity();
    }

    ionViewDidEnter() {
        this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');

        if (localStorage.getItem('atividadesInscritas'))
            this.activitiesInscIds = JSON.parse(localStorage.getItem('atividadesInscritas')) as number[];
        else
            this.activitiesInscIds = new Array<number>();

        if (this.storageProvider.get('user')) {
            this.init();
        }
        else {
            var self = this;
            self.eventSource = [];
            self.loadEvents();            
            this.alert.showConfirm('Atenção', 'Deseja efetuar o Login para continuar?', 'Sim', 'Não', function () {
                self.init();
            });
        }

        this.lockSwipes = true;
    }

    init() {
        this.utilProvider.searchInFocus = false;
        this.utilProvider.searchTerm = "";
        let self = this;
        if (self.auth.isAuthorized()) {
            if (self.utilProvider.isConnected(false)) {
                self.utilProvider.loadingShow();
                let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) as User : null;

                self.agendaProvider.getAtividadesInscritasUsuario(user.Guid, this.congresso.Ano)
                    .then(data => {
                        if (data) {

                            self.storageProvider.set('agenda', data);
                            self.setData(data);

                        }
                        setTimeout(function () {
                            self.utilProvider.loadingHide();
                            self.formatText();
                        }, 0);

                    })
                    .catch((e) => {
                      if(self.storageProvider.get('agenda')){
                      self.setData(self.storageProvider.get('agenda'))

                     setTimeout(function () {
                         self.utilProvider.loadingHide();
                         self.formatText();
                     }, 0);
                   }
                   else
                    self.utilProvider.loadingHide();
                   });
            }
            else {


                //self.utilProvider.loadingShow();
                let data = self.storageProvider.get('agenda') as Agenda[];
                self.setData(data);
                setTimeout(function () {
                    //self.utilProvider.loadingHide();
                    self.formatText();
                }, 0);

                //self.utilProvider.loadingHide();
            }
        }
    }

    getFromStorage() {
        let self = this;
        let days = self.storageProvider.get('atividadesDia') as DayProgram[];
        let data = new Array<Agenda>();

        days.forEach(d => {
            let agenda = new Agenda();
            agenda.Atividades = new Array<AgendaAtividade>();
            agenda.Dia = d.Dia.DiaData,
                self.activitiesInscIds.forEach(x => {
                    let atividade = d.Atividades.filter(a => a.AtividadeId == x)[0];
                    if (atividade) {
                        let atividadeAgenda = new AgendaAtividade();
                        atividadeAgenda.AtividadeId = atividade.AtividadeId;
                        atividadeAgenda.Color = atividade.CorAtividade;
                        atividadeAgenda.DescritivoSala = atividade.DescritivoSala;
                        atividadeAgenda.Duracao = '01:00';
                        atividadeAgenda.HoraInicioAtividade = atividade.HoraInicioAtividade;
                        atividadeAgenda.SiglaSala = atividade.SiglaSala;
                        atividadeAgenda.Tipo = 1;
                        agenda.Atividades.push(atividadeAgenda);
                    }
                });
            data.push(agenda);
        });

    }

    setData(data) {
        let self = this;
        self.days = [];
        self.eventSource = [];
        data.forEach(element => {
            self.days.push(element.Dia.toString().split("T")[0] + "T04:00:00");
            if (self.currentDay == 0) {
                let initialDay = data[0].Dia.toString().split("T")[0];
                self.currentDay = +initialDay.split("-")[2];
                self.calendar.currentDate = new Date(initialDay + "T" + 12 + ":" + data[0].Dia.toString().split(":")[1]);
            }
            self.createEvents(element);
        });

    }


    formatText() {
        this.formatHour()

        let htmlEvent = document.getElementsByName("calendar-event");
        let htmlText = document.getElementsByName("calendar-text");
        let limit = htmlEvent.length;
        for (let i = 0; i < limit; i++) {
            let subtitle = htmlEvent.item(i).getElementsByTagName("div").item(0);
            let eventHeight = htmlEvent.item(i).offsetHeight - 10;
            let titleHeight = htmlText.item(i).offsetHeight;
            let subtitleHeight = subtitle.offsetHeight;
            htmlEvent.item(i).style.paddingTop = "10px";
            htmlEvent.item(i).style.opacity = "0";
            if (eventHeight < (titleHeight + subtitleHeight)) {
                let lettersByLine = Math.round(htmlEvent.item(i).offsetWidth / 10);
                let lines = Math.round((eventHeight - subtitleHeight) / 30);
                let words = htmlText.item(i).textContent.split(" ");
                let eventDifference = eventHeight - (lines + 1) * 30;
                if (eventDifference > 10)
                    htmlEvent.item(i).style.paddingTop = Math.round(eventDifference / 2) + "px";
                if (lines < 1) {
                    subtitle.style.display = "inline";
                    lettersByLine -= 10;
                    lines = 1;
                }
                let textContent = "";
                let count = 0;
                for (let j = 0; j < lines; j++) {
                    let text = "";
                    for (let k = count; k < words.length; k++) {
                        if ((text.length + words[k].length) > lettersByLine) { break; }
                        text += " " + words[k];
                        count++;
                    }
                    textContent += " " + text;
                }
                htmlText.item(i).textContent = textContent.substr(1) + "...";
            }
            htmlEvent.item(i).style.opacity = "1";
        }
    }

    formatHour() {
        let elements = document.getElementsByClassName("calendar-hour-column");
        let limit = elements.length;
        for (let i = 0; i < limit; i++) {
            let element = elements.item(i);
            let elementTextIndex = element.textContent.lastIndexOf(' ');
            element.textContent = element.textContent.substr(0, elementTextIndex) + "h00";
        }
    }

    loadEvents() {
        this.selfCalendar.loadEvents();
    }

    onEventSelected(event) {
        this.nav.push(AtividadePage, { id: event.atividadeId });
    }

    setOpacity() {
        let htmlEvent = document.getElementsByName("calendar-event");
        for (let i = 0; i < htmlEvent.length; i++) {
            htmlEvent.item(i).style.opacity = "0";
        }
    }

    changeMode(mode) {
        this.calendar.mode = mode;
    }

    onTimeSelected(ev) {
        console.log('Selected time: ' + ev.selectedTime + ', hasEvents: ' +
            (ev.events !== undefined && ev.events.length !== 0) + ', disabled: ' + ev.disabled);

    }
    onCurrentDateChanged(event: Date) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        event.setHours(0, 0, 0, 0);
        this.isToday = today.getTime() === event.getTime();
    }
    createEvents(data: Agenda) {
        let self = this;
        data.Atividades.forEach(element => {
            let today = data.Dia.split("T")[0];
            let year = +today.split("-")[0];
            let month = +today.split("-")[1] - 1;
            let date = +today.split("-")[2];
            let horaInicial = +element.HoraInicioAtividade.split(":")[0];
            let minInicial = +element.HoraInicioAtividade.split(":")[1];
            let secInicial = +element.HoraInicioAtividade.split(":")[2];
            let horaFinal = +element.Duracao.split(":")[0];
            let minFinal = +element.Duracao.split(":")[1];
            let secFinal = +element.Duracao.split(":")[2];
            let startTime = new Date(year, month, date, horaInicial, minInicial, secInicial, 0);
            let endTime = new Date(year, month, date, horaFinal, minFinal, secFinal, 0);
            self.eventSource.push({
                title: element.DescritivoSala,
                subTitle: element.SiglaSala,
                startTime: startTime,
                endTime: endTime,
                color: element.Color,
                allDay: false,
                atividadeId: element.AtividadeId
            });

        });
    }

    onRangeChanged(ev) {
        this.formatText();
    }

    markDisabled = (date: Date) => {
        let current = new Date();
        current.setHours(0, 0, 0);
        return date < current;
    };

    getDay(day: string) {
        return new Date(day).getDate();
    }

    getMonth(day: string) {
        let month = new Date(day).getMonth().toString();
        return this.utilProvider.convertMonth(day.split("-")[1]);
    }

    changeMenus(day: string) {
        this.currentDay = new Date(day).getDate();
        this.calendar.currentDate = new Date(day);
    }

    getDate(day) {
        return new Date(day);
    }

    setTemplate(event) {
        return "template";

    }

    eventStyle(content) {

        let alphaBlack = this.utilProvider.hexToRgbA("#000000", 0.5);
        let alphaColor = this.utilProvider.hexToRgbA(content.event.color, 0.5);

        return {
            'background': alphaColor,
            'border-left': "10px solid " + content.event.color,
            'color': alphaBlack,
            'text-align': "left",
            'padding-left': "10px",
            'height': "100%"
        };
    }

    hasResult() {
        return this.eventSource.length != 0;
    }

}



// WEBPACK FOOTER //
// ./src/pages/agenda/agenda.ts